export const keyTabOrEnter = ({ keyCode }) => keyCode === 13 || keyCode === 9;
